export default __webpack_public_path__ + "static/media/aboutimage.f51b4b2e.png";